import KanbanCard from "@/components/board/KanbanCard";
import { Mail } from "lucide-react";
import { displayStage } from "@/lib/workspace";

export default function PhaseColumn({ phase, templates, byStage, users, onOpen, selectable, selectedIds, onToggleSelect, emailStages = [], onEmailStage }) {
  const stages = templates.filter((t) => phase.stages.includes(t.stage_number));
  const total = phase.stages.reduce((n, s) => n + (byStage[s]?.length || 0), 0);
  const p = phase.pastel;
  return (
    <div
      data-testid={`phase-column-${phase.id}`}
      className="rounded-lg border flex flex-col min-w-0 bg-white/60"
      style={{ borderColor: p.border }}
    >
      <div className="px-3 py-2.5 flex items-center gap-2 border-b rounded-t-lg" style={{ borderColor: p.border, background: p.tint }}>
        <span className="text-[10px] font-extrabold uppercase tracking-[0.18em]" style={{ color: p.accent }}>{phase.name}</span>
        <span className="text-[10px] text-[#15233B]/45 font-semibold hidden sm:inline">
          Stages {displayStage(phase.stages[0])}–{displayStage(phase.stages[phase.stages.length - 1])}
        </span>
        <span data-testid={`phase-count-${phase.id}`} className="ml-auto text-[11px] font-bold px-2 py-0.5 rounded-full bg-white/85" style={{ color: p.accent }}>{total}</span>
      </div>
      <div className="p-2.5 space-y-3 overflow-y-auto max-h-[calc(100vh-270px)]">
        {total === 0 && <div className="text-xs italic text-[#15233B]/40 px-2 py-4">No leads in this phase.</div>}
        {stages.map((t) => {
          const cards = byStage[t.stage_number] || [];
          if (!cards.length) return null;
          return (
            <div key={t.stage_number} data-testid={`phase-stage-group-${t.stage_number}`}>
              <div className="flex items-center gap-1.5 px-1 mb-1.5">
                <span className="h-4 w-4 rounded-full grid place-items-center text-[9px] font-extrabold bg-[#15233B] text-white shrink-0">{displayStage(t.stage_number)}</span>
                <span className="text-[11px] font-bold text-[#15233B]/80 truncate">{t.name}</span>
                <span className="ml-auto text-[10px] font-bold text-[#15233B]/45">{cards.length}</span>
                {onEmailStage && emailStages.includes(t.stage_number) && (
                  <button type="button" data-testid={`email-all-stage-${t.stage_number}-phase`} onClick={() => onEmailStage(t, cards)}
                    className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-extrabold uppercase tracking-[0.08em] bg-[#FFCB05] text-[#15233B] hover:bg-[#FBC02D]">
                    <Mail className="h-2.5 w-2.5" /> Email all
                  </button>
                )}
              </div>
              <div className="space-y-2">
                {cards.map((c) => (
                  <KanbanCard
                    key={c.id}
                    card={c}
                    template={t}
                    users={users}
                    onOpen={onOpen}
                    selectable={selectable}
                    selected={selectedIds?.has(c.id)}
                    onToggleSelect={onToggleSelect}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
